import { PageHero } from "../components/common/PageHero";
import { site } from "../data/content";

const content = {
    privacy: {
        title: "Privacy Policy",
        overline: "Legal",
        sections: [
            { h: "Information We Collect", p: "We collect information you provide through our contact and requirement forms, including your name, company, email, mobile number and requirement details, solely to respond to your enquiry." },
            { h: "How We Use Information", p: "Submitted information is used to understand and fulfil your manpower or construction requirements, respond to enquiries, and provide relevant services. We do not sell your personal information to third parties." },
            { h: "Data Security", p: "We apply reasonable technical and organizational measures to protect submitted information against unauthorized access, disclosure or misuse." },
            { h: "Your Choices", p: "You may request access to, correction of, or deletion of the information you have submitted by contacting us at " + site.email + "." },
        ],
    },
    terms: {
        title: "Terms & Conditions",
        overline: "Legal",
        sections: [
            { h: "Use of Website", p: "By accessing this website you agree to use it for lawful purposes only and in a manner that does not infringe the rights of, or restrict the use of, this website by any third party." },
            { h: "Services", p: "Information about services on this website is provided for general guidance. Specific engagements are governed by separate written agreements between FRONTX and the client." },
            { h: "Intellectual Property", p: "All content, branding and materials on this website are the property of FRONTX Integrated Services India Private Limited unless otherwise stated." },
            { h: "Limitation of Liability", p: "FRONTX shall not be liable for any indirect or consequential loss arising from the use of this website." },
        ],
    },
    disclaimer: {
        title: "Disclaimer",
        overline: "Legal",
        sections: [
            { h: "General Information", p: "The content on this website is for general informational purposes only. While we endeavour to keep information accurate and up to date, we make no representations or warranties of any kind about completeness or accuracy." },
            { h: "No Guarantees", p: "This website does not make any exaggerated or unverifiable claims. Any statistics or capabilities described represent our service scope and are not guarantees of specific outcomes." },
            { h: "External Links", p: "This website may contain links to external sites. FRONTX is not responsible for the content or practices of any third-party websites." },
        ],
    },
};

export default function Legal({ page }) {
    const data = content[page];
    return (
        <>
            <PageHero overline={data.overline} breadcrumb={data.title} title={data.title} />
            <section className="bg-white">
                <div className="mx-auto max-w-[900px] px-5 lg:px-10 py-24 lg:py-32 space-y-10">
                    {data.sections.map((s) => (
                        <div key={s.h}>
                            <h2 className="font-display font-bold text-xl lg:text-2xl text-navy tracking-tight">{s.h}</h2>
                            <p className="mt-3 text-slate-600 leading-relaxed">{s.p}</p>
                        </div>
                    ))}
                    <p className="text-sm text-slate-400 pt-6 border-t border-slate-200">
                        {site.name} • CIN: {site.cin}
                    </p>
                </div>
            </section>
        </>
    );
}
